module.exports = __webpack_public_path__ + "img/claymation.2dbaf990.png";